import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import FilterContentBank from "../../FilterAPI/FilterContentBank"
import classes from "./UploadChooseStep.module.css"
import ContentBankItem from "../../ContentBankItem/ContentBankItem"
import { onKeyDown } from "../../../../../service";

const UploadChooseStep = ({ setUploadStep, listFilter, filteredlist, items, selectedProject, setFilteredList, setSelectedProject }) => {

    const { texts, direction } = useSelector(state => state.translate);

    const [filtersInputs, setFilterInputs] = useState();

    useEffect(() => {
        setFilterInputs(Object.keys(listFilter.filters).reduce((inputs, filter) => {
            inputs[filter] = '';
            return inputs
        }, {}))
    }, [])

    const filter = (e, type) => {

        setFilterInputs(prevFilterInputs => {
            const newFilterInputs = { ...prevFilterInputs }
            newFilterInputs[type] = e;
            return newFilterInputs;
        });

        let currentInputs = {
            ...filtersInputs
        }
        currentInputs[type] = e
        const list = items && items.filter(p =>
            Object.keys(filtersInputs).map(key => {
                switch (key) {
                    case "free":
                        if (!currentInputs[key] || (currentInputs[key] && ["name"].some(field => p[field] && p[field].includes && p[field].includes(currentInputs[key]))))
                            return true;
                        return false
                    case "ideId":
                        if (!currentInputs[key] || (currentInputs[key] && p?.ide?.id == currentInputs[key]))
                            return true;
                        return false;
                    case "lang":
                        const filterBy = currentInputs[key] === texts.without ? null : currentInputs[key];
                        if (!filterBy || p?.lang == filterBy)
                            return true;
                        return false;
                    default:
                        if (!currentInputs[key] || (currentInputs[key] && currentInputs[key].toString() && p[key] && p[key].toString().includes(currentInputs[key].toString())))
                            return true;
                        else
                            return false;
                }
            }).every(p => p === true)
        )
        setFilteredList(list)
    }
    const handleContinueBtn = (num) => {
        if (selectedProject)
            setUploadStep(2)
    }
    return (
        <div className={classes.UploadProjectPopup}>
            <div className={classes.FilterAPIContainer}>
                {Object.keys(listFilter.filters).map(f =>
                    <FilterContentBank key={f} type={listFilter.filters[f].type} list={listFilter.filters[f].list} text={listFilter.filters[f].title} filterKey={f} handleChange={filter} />
                )}
            </div>
            <div className={classes.ContentBankItemListWarrper}>
                <div className={`${classes[direction]} ${classes.ContentBankItemList}`}>
                    <div className={classes.ContentBankList}>
                        {filteredlist && filteredlist.map((c, index) =>
                            <div key={index} className={`${classes.ProjectItem} ${selectedProject == c ? classes.Selected : ''}`}>
                                <ContentBankItem contentBankItem={c} setContentBankItem={setSelectedProject}></ContentBankItem>
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes.Footer}>
                    <div className={` ${classes.ContinueBtn} ${!selectedProject && classes.DisableBtn}`} onClick={() => { handleContinueBtn(2) }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleContinueBtn(2))}> {texts.continue}</div>
                </div>
            </div>
        </div>
    )
}
export default UploadChooseStep